<script setup>
import { computed } from 'vue';
import BaseNode from './BaseNode.vue';
import OutputRow from './OutputRow.vue';

const props = defineProps({
  id: { type: String, required: true },
  data: { type: Object, default: () => ({}) },
  selected: { type: Boolean, default: false },
});

const buttons = computed(() => props.data.config?.buttons || []);
</script>

<template>
  <BaseNode
    type="buttons"
    :title="data.title"
    :selected="selected"
    :has-error="!(data.config && data.config.body) || !buttons.length || buttons.length > 3"
  >
    <p class="mb-1 whitespace-pre-line line-clamp-2">
      {{ data.config?.body || $t('FLOWS.BUILDER.CANVAS.EMPTY_TEXT') }}
    </p>
    <div class="border-t border-n-weak pt-1">
      <OutputRow
        v-for="button in buttons"
        :key="button.id"
        :handle-id="`btn-${button.id}`"
        :label="button.title || button.id"
      />
      <OutputRow handle-id="fallback" :label="$t('FLOWS.BUILDER.CANVAS.FALLBACK_OUTPUT')" muted />
    </div>
  </BaseNode>
</template>
